<script>
    import vSelect from 'vue-select'
    import {Form} from '../../../helpers/Form/Form'

    export default {
        name: 'SummerCampsSeoSearchForm',
        props: {
            language: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        components: {'v-select': vSelect},
        data() {
            return {
                municipalities: [],
                city_search: '',
                selected: ''
            }
        },
        watch: {
            city_search(val) {
                if (!_.isObject(val)) {
                    this.searchSummerCampByCity()
                }
            }
        },
        methods: {
            onSearchCity(search, loading) {
                this.searchCity(loading, search, this);
            },
            searchCity: _.debounce((loading, search, vm) => {
                axios({
                    method: 'get',
                    url: `/municipalities?term=${search}`,
                }).then((response) => {
                    vm.municipalities = response.data.municipalities;
                    loading(false);
                }).catch((error) => {
                    this.message = 'Error';
                    loading(false);
                });
            }),
            searchSummerCampByCity() {
                var self = this;
                let source = route('summer-camps.home');

                if (this.city_search) {    
                    if (this.language.hasOwnProperty('id')) {
                        window.location.href = `${source}?municipality=${this.selected}&latitude=${this.city_search.latitude}&longitude=${this.city_search.longitude}&languages[]=${this.language.id}`;
                    } else {
                        window.location.href = `${source}?municipality=${this.selected}&latitude=${this.city_search.latitude}&longitude=${this.city_search.longitude}`;
                    }
                } else {
                    window.location.href = `${source}?municipality=${this.selected}`;
                }
            },
            setSelected(val){
                this.selected = val.name;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/seo/summer_camps/SummerCampsSeoSearchForm.vue